<div class="body-2 text-muted" *ngIf="!scrapService.events.length">
  <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
  {{ 'general.api_scrap_empty' | translate }}
</div>
<div class="content-with-sidebar with-footer" *ngIf="scrapService.events.length">
  <div class="content">
    <div [ngClass]="{'mobile-hidden': processScrapViewOpened}" class="heading-1">{{ 'general.api_scrap' | translate }}</div>
    <div *ngIf="processScrapViewOpened" class="mobile flex space-between max-width">
      <div class="heading-1">{{ 'general.api_scrap_proceed' | translate }}</div>
      <div>
        <button mat-button class="icon-button" (click)="processScrapViewOpened = false">
          <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
        </button>
      </div>
    </div>
    <mat-card appearance="outlined" [ngClass]="{'mobile-hidden': processScrapViewOpened}">
      <app-data-table *ngIf="tableConfig && Object.keys(scrapService.selectionMap?.events)?.length"
                      [(config)]="tableConfig" [useResponsive]="true" [useCartSelectionMap]="true"
                      [data]="scrapService.events" [cartService]="scrapService"></app-data-table>
    </mat-card>
    <ng-container *ngIf="processScrapViewOpened">
      <app-text-input class="max-width" [type]="TextInputType.Textarea" [label]="'general.api_scrap_description'" [(value)]="description" [required]="true"></app-text-input>
      <table class="totals-table">
        <tbody>
        <tr *ngIf="scrapService.ticketQuantity">
          <th>{{ 'general.api_cart_table_items_total' | translate }}</th>
          <td><span class="price">{{ scrapService.ticketQuantity | quantityInPcs }}</span></td>
        </tr>
        <tr *ngIf="scrapService.cartTotalPrice">
          <th>{{ 'general.api_cart_table_items_price_total' | translate }}</th>
          <td><span class="price">{{ scrapService.cartTotalPrice | price }}</span></td>
        </tr>
        <ng-container *ngFor="let fee of scrapService.cartFees">
          <tr *ngIf="fee.total">
            <th>{{ fee.name | translateValue }}</th>
            <td><span class="price">{{ fee.total | price }}</span></td>
          </tr>
        </ng-container>
        <tr *ngIf="scrapService.cartTotalDelivery">
          <th>{{ 'general.api_reports_delivery_fee' | translate }}&nbsp;
            ({{scrapService.cartTotalDelivery.name | translate}})</th>
          <td><span class="price">{{ scrapService.cartTotalDelivery.price | price }}</span></td>
        </tr>
        <ng-container *ngFor="let fee of scrapService.cartSalespointFees">
          <tr *ngIf="fee.total">
            <th>{{ fee.name | translateValue }}</th>
            <td><span class="price">{{ fee.total | price }}</span></td>
          </tr>
        </ng-container>
        </tbody>
        <tfoot>
        <tr>
          <th>{{ 'general.api_scrap_total' | translate }}:</th>
          <th class="align-right"><span class="price">{{ scrapService.totalScrapSum | price }}</span></th>
        </tr>
        </tfoot>
      </table>
    </ng-container>
    <footer class="mobile">
      <mat-dialog-actions class="flex flex-column">
        <ng-container *ngIf="!processScrapViewOpened">
          <div class="flex space-between max-width">
            <div>
              <span class="text-muted">{{ 'general.api_cart_table_items_total' | translate }}: </span><br>
              <span class="heading-3 bold">{{ scrapService.ticketQuantity | quantityInPcs }}</span>
            </div>
            <div class="align-right">
              <span class="text-muted">{{ 'general.api_scrap_total' | translate }}: </span><br>
              <span class="heading-3 bold">
                {{ scrapService.totalScrapSum | price }}
              </span>
            </div>
          </div>
          <div class="flex flex-grow max-width">
            <button mat-stroked-button color="primary" (click)="cancelScrapping()">
              {{ isFiscal ? 'general.api_fiscal_scrap_cancel' : 'general.api_scrap_cancel' | translate }}
            </button>
            <button mat-flat-button color="primary" (click)="processScrapViewOpened = true">
              {{ isFiscal ? 'general.api_fiscal_scrap_register' : 'general.api_scrap_register' | translate }}
            </button>
          </div>
        </ng-container>
        <div class="flex flex-grow max-width" *ngIf="processScrapViewOpened">
          <button mat-button (click)="processScrapViewOpened = false">
            {{ isFiscal ? 'general.api_fiscal_scrap_undo' : 'general.api_scrap_undo' | translate }}
          </button>
          <button mat-flat-button color="primary" (click)="registerScrap()" [disabled]="!canSend">
            {{ isFiscal ? 'general.api_fiscal_scrap_register' : 'general.api_scrap_register' | translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </footer>
  </div>
  <div class="sidebar desktop">
    <app-text-input class="max-width" [type]="TextInputType.Textarea" [label]="'general.api_scrap_description'" [(value)]="description" [required]="true"></app-text-input>
    <br>
    <ng-template #transactionTotalRow let-rowName="rowName" let-amount="amount" let-price="price">
      <tr *ngIf="amount || price">
        <th>{{ rowName | translateValue }}</th>
        <td *ngIf="amount"><span class="price">{{ amount | quantityInPcs }}</span></td>
        <td *ngIf="price"><span class="price">{{ price | price }}</span></td>
      </tr>
    </ng-template>
    <table class="totals-table">
      <tbody>
        <ng-container *ngTemplateOutlet="transactionTotalRow;
              context:{rowName: 'general.api_cart_table_items_total', amount: scrapService.ticketQuantity}"></ng-container>
        <ng-container *ngTemplateOutlet="transactionTotalRow;
              context:{rowName: 'general.api_cart_table_items_price_total', price: scrapService.cartTotalPrice}"></ng-container>
        <ng-container *ngFor="let fee of scrapService.cartFees">
          <ng-container *ngTemplateOutlet="transactionTotalRow; context:{rowName: fee.name, price: fee.total}"></ng-container>
        </ng-container>
        <tr *ngIf="scrapService.cartTotalDelivery">
          <th>{{ 'general.api_reports_delivery_fee' | translate }}&nbsp;
            ({{scrapService.cartTotalDelivery.name | translate}})</th>
          <td><span class="price">{{ scrapService.cartTotalDelivery.price | price }}</span></td>
        </tr>
        <ng-container *ngFor="let fee of scrapService.cartSalespointFees">
          <ng-container *ngTemplateOutlet="transactionTotalRow; context:{rowName: fee.name, price: fee.total}"></ng-container>
        </ng-container>
      </tbody>
      <tfoot>
        <tr>
          <th>{{ 'general.api_scrap_total' | translate }}:</th>
          <th class="align-right"><span class="price">{{ scrapService.totalScrapSum | price }}</span></th>
        </tr>
      </tfoot>
    </table>
    <br>
    <div class="flex flex-grow">
      <button mat-stroked-button color="primary" (click)="cancelScrapping()">
        {{ authService.checkSalespointProperty('fiscal_procedures_by') ? 'general.api_fiscal_scrap_cancel' : 'general.api_scrap_cancel' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="registerScrap()" [disabled]="!canSend">
        {{ authService.checkSalespointProperty('fiscal_procedures_by') ? 'general.api_fiscal_scrap_register' : 'general.api_scrap_register' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Ticket table templates -->
<ng-template #tableEvent let-item="item">
  <span class="semi-bold">{{ item.title | translateValue }}</span>
  <br>{{ item.venueTitle }}
</ng-template>
<ng-template #tableDate let-item="item">
  <ng-container *ngIf="!item.isSeason">{{ item.eventDate | period: { hasTimeInPeriod: true } }}</ng-container>
</ng-template>
<ng-template #tableTicketPrice let-item="item">
  <span class="title semi-bold white-space-no-wrap">-{{ item | ticketPrice:true }}</span>
</ng-template>
<ng-template #tableBlankNumber let-item="item">
  <app-numeric-input [small]="true" [(value)]="item.blankNumber"></app-numeric-input>
</ng-template>
